import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DeliveryDiscountBranchesMiniEntity } from '../../domain/entities/DeliveryBranchesMiniEntity'

export class DeliveryDiscountBranchesMiniModel extends DeliveryDiscountBranchesMiniEntity {
  constructor(dataDto: DeliveryDiscountBranchesMiniEntity) {
    super()
    mapEntityProperties<DeliveryDiscountBranchesMiniModel>(this, dataDto, {})
  }
}
